import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayFeatureListComponent } from "@m19-board/overlay/overlay-feature-list/overlay-feature-list.component";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";

export type PitchedFeature =
  | "sp"
  | "sb"
  | "sd"
  | "dsp"
  | "tacos"
  | "traffic_analysis"
  | "amc"
  | "account360"
  | "product360";

@Component({
  selector: "app-feature-pitch-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, OverlayFeatureListComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="promo"
      [title]="title()"
      [subtitle]="t('feature-pitch.' + feature() + '_subtitle')"
    >
      <app-overlay-feature-list overlayBody [featureKeys]="benefitKeys()" />
      <div overlayCta><ng-content /></div>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturePitchOverlayComponent {
  readonly title = input.required<string>();
  readonly feature = input.required<PitchedFeature>();

  protected readonly benefitKeys = computed(() => [1, 2, 3].map((i) => `feature-pitch.${this.feature()}_benefit_${i}`));
}
